import React from 'react';

import { dataHooks } from '../../constants';
import {
  FieldSetProps,
  LegendPlacement,
  LegendSize,
} from '../../FieldSet.types';
import { Text } from '../../../Text';
import { SIZES, SKINS, WEIGHTS } from '../../../Text/constants';

import { st, classes } from './Suffix.st.css';

const CharactersLeft = ({
  lengthLeft,
  labelSize,
}: {
  lengthLeft?: number;
  labelSize: LegendSize;
}) => {
  if (lengthLeft === undefined) return null;

  const colorProps =
    lengthLeft >= 0 ? { light: true, secondary: true } : { skin: SKINS.error };

  return (
    <Text
      className={st(classes.charCount, {
        labelSize,
      })}
      size={SIZES.small}
      weight={WEIGHTS.normal}
      {...colorProps}
      dataHook={dataHooks.counter}
      children={lengthLeft}
    />
  );
};

type Props = Pick<FieldSetProps, 'suffix' | 'charCount'> & {
  labelSize: LegendSize;
  labelPlacement: LegendPlacement;
  hasInlineElements: boolean;
};

const Suffix = ({
  suffix,
  charCount,
  labelPlacement,
  hasInlineElements,
  labelSize,
}: Props) => {
  return (
    <div
      aria-hidden
      data-hook={dataHooks.suffix}
      className={st(classes.root, {
        noLabel: labelPlacement !== 'top',
        hasInlineElements,
      })}
    >
      {suffix ?? (
        <CharactersLeft lengthLeft={charCount} labelSize={labelSize} />
      )}
    </div>
  );
};

export { Suffix };
